import React from "react";

const ContentTakeawaysBlock = ({ block }) => {
    const items = block?.items?.filter((item) => item?.text?.trim()) || [];

    if (!block?.title || !items.length) {
        return null;
    }

    return (
        <aside className="content-takeaways" aria-label={block.title}>
            {block.eyebrow && (
                <div className="content-takeaways__eyebrow">
                    {block.eyebrow}
                </div>
            )}
            <div className="content-takeaways__box">
                {block.label && (
                    <div className="content-takeaways__label">
                        {block.label}
                    </div>
                )}
                <h2 className="content-takeaways__title">{block.title}</h2>
                <ol className="content-takeaways__list">
                    {items.map((item, index) => (
                        <li className="content-takeaways__item" key={index}>
                            <span className="content-takeaways__number">
                                {String(index + 1).padStart(2, "0")}
                            </span>
                            <div
                                className="content-takeaways__text"
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                        </li>
                    ))}
                </ol>
            </div>
        </aside>
    );
};

export default ContentTakeawaysBlock;
